import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { Text } from '@zillow/constellation';
import { Link } from '@zillow/zrs-comet';

import { RMWContext } from 'app/shared/providers/RMWContext';

const propTypes = {
    disablePublishIfDuplicatePaidListingPosted: PropTypes.bool.isRequired,
    isActive: PropTypes.bool.isRequired,
};

const ErrorMessage = ({ disablePublishIfDuplicatePaidListingPosted, isActive }) => {
    const { paths: { listingDeclined } } = useContext(RMWContext);
    const accountVerificationEmail = 'account_verification@zillow.com';

    return (
        <div className="ErrorMessage">
            {(disablePublishIfDuplicatePaidListingPosted && !isActive) ? (
                <Text fontType="body">
                    This property is currently listed from another source.
                    &nbsp;
                    <Link href={listingDeclined} target="_blank">
                        Learn more
                    </Link>
                </Text>
            ) : (
                <Text fontType="body">
                    {!isActive ? 'This listing cannot be published'
                        : 'Your listing has been declined'}
                    . Please contact&nbsp;
                    <Link href={`mailto:${accountVerificationEmail}`} escape={true}>
                        Account Verification
                    </Link>
                    .
                </Text>
            )}
        </div>
    );
};

ErrorMessage.propTypes = propTypes;

export default ErrorMessage;
